import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import baseStyle from '../style/checkboxAndRadio.module.scss.js';

const RadioInputIcon = (props) => {
    const { hasError } = props;
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: classNames(baseStyle['z-radio__icon'], {
            [baseStyle['z-radio__icon--error']]: hasError,
        }), children: jsxs("g", { transform: "translate(1.5 1.5)", fill: "none", fillRule: "evenodd", children: [jsx("circle", { className: baseStyle['z-radio__checkmark'], fill: "currentColor", cx: "10.5", cy: "10.5", r: "7.9" }), jsx("circle", { strokeWidth: "1.5", cx: "10.5", cy: "10.5", r: "11.2", stroke: "currentColor" })] }) }));
};

export { RadioInputIcon };
//# sourceMappingURL=RadioInputIcon.js.map
